import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { SlackBlocksModule } from 'src/app/components/slack-blocks/slack-blocks.module';

import { SurveyAnalyticsPage } from '../survey-analytics/survey-analytics.page';

import { SurveysComponent } from './surveys.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxDatatableModule,
    SlackBlocksModule,
    NgxTippyModule,
    SurveyAnalyticsPage,
  ],
  declarations: [SurveysComponent],
  exports: [SurveysComponent, SurveyAnalyticsPage],
})
export class SurveysModule {}
